/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Map_CreditInputs */

const en_services_map_credit = /** @type {((inputs: Services_Map_CreditInputs) => LocalizedString) & { parts: (inputs: Services_Map_CreditInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Services_Map_CreditInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Port data powered by waykite.com`)
		}),
		{
			parts: /** @type {(inputs: Services_Map_CreditInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Port data powered by " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "waykite.com" }, { type: "markup-end", name: "link", options: {}, attributes: {} }])
			})
		}
	)
);

const zh_services_map_credit = /** @type {((inputs: Services_Map_CreditInputs) => LocalizedString) & { parts: (inputs: Services_Map_CreditInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Services_Map_CreditInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`港口数据由 waykite.com 提供`)
		}),
		{
			parts: /** @type {(inputs: Services_Map_CreditInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "港口数据由 " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "waykite.com" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: " 提供" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Port data powered by waykite.com" |
*
* @param {Services_Map_CreditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_map_credit = /** @type {((inputs?: Services_Map_CreditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & { parts: (inputs?: Services_Map_CreditInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Services_Map_CreditInputs, { locale?: "en" | "zh" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Services_Map_CreditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh") return zh_services_map_credit(inputs)
			return en_services_map_credit(inputs)
		}),
		{
			parts: /** @type {(inputs?: Services_Map_CreditInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh") return /** @type {{ parts?: (inputs: Services_Map_CreditInputs) => import('../runtime.js').MessagePart[] }} */ (zh_services_map_credit).parts?.(inputs) ?? [{ type: "text", value: zh_services_map_credit(inputs) }]
				return /** @type {{ parts?: (inputs: Services_Map_CreditInputs) => import('../runtime.js').MessagePart[] }} */ (en_services_map_credit).parts?.(inputs) ?? [{ type: "text", value: en_services_map_credit(inputs) }]
			})
		}
	)
);